import React from 'react';
import { ToastContext, Dropdown, Modal, Button } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../context/useAppContext';
import PropTypes from 'prop-types';
import SessionModel from '../../../models/sessionModel';

export function DeletionModal({ itemsToDelete = null, onClose = () => {}, onSave = () => {}, totalItemsSelected = 0 }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [{ event, organization }] = useAppContext();
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const onSubmit = React.useCallback(() => {
        setIsSubmitting(true);
        SessionModel.perform_action('delete', itemsToDelete, { organization, event })
            .then(() => {
                toast.success(t(`ticket.sessions.actions.delete.success`, { count: itemsToDelete.length }));
                onSave();
            })
            .catch(e => {
                console.error(e);
                toast.error(t(`ticket.sessions.actions.delete.error`, { count: itemsToDelete.length }));
            })
            .finally(() => {
                setIsSubmitting(false);
                onClose();
            });
    }, [event, organization, toast, SessionModel, itemsToDelete, onSave, onClose]);

    if (!itemsToDelete || itemsToDelete.length === 0) {
        return null;
    }

    return (
        <Modal
            allowExternalClosing={false}
            open={Boolean(itemsToDelete)}
            onClose={onClose}
            title={t('ticket.sessions.actions.delete.modalTitle')}
            submitButton={<Button primary disabled={isSubmitting} isLoading={isSubmitting} onClick={onSubmit} label={t('ticket.common.action.save')} />}
            cancelButton={<Button disabled={isSubmitting} onClick={onClose} label={t('ticket.common.action.cancel')} />}
        >
            {totalItemsSelected === 1
                ? t('ticket.sessions.actions.delete.modalBodyOne')
                : t('ticket.sessions.actions.delete.modalBody', {
                      count: itemsToDelete.length,
                      total: totalItemsSelected
                  })}
            {}
        </Modal>
    );
}

DeletionModal.propTypes = {
    itemsToDelete: PropTypes.array,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    totalItemsSelected: PropTypes.number
};

export function DeleteAction({ objects: selectedSessions, onSave = () => {} }) {
    const [itemsToDelete, setItemsToDelete] = React.useState([]);
    const { t } = useTranslation();

    const itemsFiltered = React.useMemo(() => {
        if (!selectedSessions) {
            return [];
        }
        return selectedSessions.filter(s => Number(s.quota_taken) === 0 || s.quota_taken === null);
    }, [selectedSessions]);

    return (
        <>
            <DeletionModal itemsToDelete={itemsToDelete} onClose={() => setItemsToDelete(null)} totalItemsSelected={selectedSessions.length} onSave={onSave} />
            <Dropdown.Item disabled={!itemsFiltered.length} onClick={() => setItemsToDelete(itemsFiltered)} deleteItem>
                {t('ticket.common.action.delete')}
            </Dropdown.Item>
        </>
    );
}

DeleteAction.propTypes = {
    objects: PropTypes.array, //required
    onSave: PropTypes.func
};
